import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../components/Loading";
import { useLoginForm } from "../App";
import { useNavigate } from "react-router-dom";
import useAxios from "../hooks/useAxios";

function JoinusModel({closeModel}) {
    // const isMobile = false;
    const [isMobile, setIsMobile] = useState(false);
    const defaultFormData = { email: "", phoneNumber: "" };
    const [buttonLoading, setButtonLoading] = useState(false);
    const [formData, setFormData] = useState(defaultFormData);
    const [agreed, setAgreed] = useState(false);
    const navigate = useNavigate();
    const { setLoginForm } = useLoginForm();
    const { post } = useAxios();
  
    const handleChange = (e) => {
      if (buttonLoading) return;
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };
  
    const handleCheckboxChange = (e) => {
      if (buttonLoading) return;
      setAgreed(e.target.checked);
    };
  
    const handleSubmit = async (e) => {
      e.preventDefault();
  
      if (buttonLoading) return;
  
      if (!formData.email) {
        toast.error("Email is required!");
        return;
      }
  
      const email = formData.email.toLowerCase().trim();
  
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        toast.error("Invalid email address!");
        return;
      }
      if (!agreed) {
        toast.error("You must agree to the terms!");
        return;
      }
  
      setButtonLoading(true);
  
      await post(
        process.env.REACT_APP_EMAIL_SIGNUP_API_URL,
        {
          email,
          phone_number: formData.phoneNumber.split("-").join(""),
          purpose: "send_email_verification_link",
        },
        (response) => {
          if (response.data.data.status === "active") {
            setLoginForm({ email });
            navigate("/login");
          }
        }
      );
  
      setButtonLoading(false);
      setFormData(defaultFormData);
      closeModel();
    };

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const checkScreenSize = () => {
          setIsMobile(window.innerWidth <= 768);
        };
        
        window.addEventListener('resize', checkScreenSize);
    
        return () => window.removeEventListener('resize', checkScreenSize);
      }, []);

    return (
        <div className="fixed z-[50] inset-0 isolate flex justify-center items-center bg-black bg-opacity-60 font-fira h-full">
            <div className="w-[90%] rounded-[16px] max-w-[1296px] flex flex-col relative overflow-auto lg:max-h-full max-h-[85%]">
                <div className={`flex lg:flex-row flex-col`}>
                    {/* Left Side - Benefits Section */}
                    <div className={`${isMobile ? 'w-full' : 'lg:w-[53.7%]'} py-4 lg:py-[40px] pl-4 lg:pl-[40px] pr-4 lg:pr-0 text-white`} style={{ backgroundColor: '#00066A' }}>
                    <h2 className="font-bold lg-xl:text-[50px] lg-xl:leading-[65px] lg:text-[40px] lg:leading-[55px] sm:text-[32px] sm:leading-[45px] text-[28px] leading-[40px] xs:pt-0 pt-[40px] tracking-normal uppercase font-fira mb-20px">
                            WHY JOIN <span style={{ color: '#D30039' }}>FIRED UP TO VOTE!</span>
                        </h2>
                        <ul className="">
                            {[
                                'Increase Voter Turnout',
                                'Statistically Proven Results',
                                'Free Software Tool',
                                'Easy to Use',
                                'Convenient / Use Tool From Anywhere',
                                'Strengthen Civic Engagement'
                            ].map((benefit, index) => (
                                <li key={index} className="flex items-center mb-[10px]">
                                    <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none" className="lg-xl:w-[25px] lg-xl:h-[25px] w-[20px] h-[20px]">
                                            <path d="M25 13C25 19.9052 19.3548 25.5 12.5 25.5C5.59476 25.5 0 19.9052 0 13C0 6.14516 5.59476 0.5 12.5 0.5C19.3548 0.5 25 6.14516 25 13ZM11.0383 19.6532L20.3125 10.379C20.6149 10.0766 20.6149 9.52218 20.3125 9.21976L19.1532 8.11089C18.8508 7.75806 18.3468 7.75806 18.0444 8.11089L10.4839 15.6714L6.90524 12.1431C6.60282 11.7903 6.09879 11.7903 5.79637 12.1431L4.6371 13.252C4.33468 13.5544 4.33468 14.1089 4.6371 14.4113L9.87903 19.6532C10.1815 19.9556 10.7359 19.9556 11.0383 19.6532Z" fill="#D30039"></path>
                                        </svg>
                                    </span>
                                    <span className="xs:ml-[15px] ml-[10px] xl:text-22px xl:leading-[35.2px] text-[20px] leading-[28px] font-fira font-medium">{benefit}</span>
                                </li>
                            ))}
                        </ul>
                        <div className="bg-white w-[243px] h-[140px] mt-[30px] mx-auto flex items-center justify-center mb-[30px] rounded-[10px]">
                            <img src="./hero-img_sm.png" alt="hero" className="object-contain p-3" />
                        </div>
                    </div>

                    {/* Right Side - Form Section */}
                    <div className={`${isMobile ? 'w-full' : 'lg:w-[50%]'} bg-white lg:py-[40px] lg:pr-[40px] py-4 pr-4 lg:pl-[40px] pl-4 relative`}>

                        <div>
                            
                            <div className="my-20px xl:text-22px xl:leading-[28.6px] text-[20px] leading-normal font-fira font-normal">
                                After you submit your email, you will immediately receive an email from support@fireduptovote.com (check Spam) with a <b>link to create your Fired Up To Vote account</b> to <b>compile</b> your "My Voter List".
                            </div>

                            <div>
                                <div className="lg:mb-[20px] mb-[15px]">
                                    <label className="xl:text-[20px] font-medium xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira mb-[10px] block">
                                        Email <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        name="email"
                                        placeholder="Enter Email"
                                        className="w-full px-[10px] py-[4px] xs:px-[10px] xs:py-[7px] md:px-[20px] md:py-[10px] border border-[#DDDDDD] rounded-[8px] focus-visible:outline-cherry text-xl placeholder-black placeholder:text-lg lg-xl:placeholder:text-xl"
                                        value={formData.email || ''}
                                        onChange={handleChange}
                                        required
                                        style={{ placeholderColor: 'red' }} // Changed this line to change the color of the placeholder text
                                    />
                                </div>

                                <div className="lg:mb-[20px] mb-[15px]">
                                    <label className="xl:text-[20px] font-medium xl:leading-[26px] text-[18px] leading-[22px] tracking-normal font-fira mb-[10px] block">
                                        Cell Phone Number <span className="text-red-500">*</span>
                                    </label>
                                    <input
                                        type="tel"
                                        name="phoneNumber"
                                        placeholder="Enter Cell Phone Number"
                                        className="w-full px-[10px] py-[4px] xs:px-[10px] xs:py-[7px] md:px-[20px] md:py-[10px] border border-[#DDDDDD] rounded-[8px] focus-visible:outline-cherry text-xl placeholder-black placeholder:text-lg lg-xl:placeholder:text-xl"
                                        value={formData.phoneNumber || ''}
                                        onChange={(e)=> {
                                            if (e.target.value.split("-").join("").length > 10) return;

                                            e.target.value = e.target.value
                                              .replace(/\D/g, "") // Remove any non-digit characters
                                              .replace(/(\d{3})(\d{1,3})?(\d{1,4})?/, function (_, p1, p2, p3) {
                                                let formatted = p1;
                                                if (p2) formatted += "-" + p2;
                                                if (p3) formatted += "-" + p3;
                                                return formatted;
                                              });
                                        
                                              handleChange(e);
                                        }}
                                        required
                                    />
                                </div>
                                        

                                <div className="inline-flex items-start gap-2 lg:mb-[20px] mb-[15px]">
                                    <label className="flex items-center cursor-pointer relative lg:mt-[3px] mt-[2px]">
                                        <input type="checkbox" 
                                            id="check2" 
                                            name="agreed"
                                            className="peer h-5 w-5 cursor-pointer transition-all appearance-none rounded shadow hover:shadow-md border border-slate-300 checked:bg-[#D30039] checked:border-[#D30039]"
                                            checked={agreed}
                                            disabled={buttonLoading}
                                            onChange={handleCheckboxChange}
                                        />
                                        <span className="absolute text-white opacity-0 peer-checked:opacity-100 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                                            <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" stroke-width="1">
                                                <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"></path>
                                            </svg>
                                        </span>
                                    </label>
                                    <span className="xl:text-[20px] font-normal xl:leading-[26px] text-[18px] leading-normal tracking-normal font-fira cursor-pointer select-none translate-y-[-1px]">
                                        By checking this box, you agree to receive automated
                                        communications from us.
                                    </span>
                                </div>
                         

                                <button
                                    type="submit"
                                    disabled={buttonLoading}
                                    className={`uppercase xl:text-22px lg:mx-0 mx-auto xl:leading-[23.4px] text-18px leading-[23px] font-fira font-normal text-white flex items-center xl:py-[14.3px] xl:px-[30px] py-2 px-3 cursor-pointer ${(buttonLoading) ? 'bg-gray-400 cursor-not-allowed' : 'hover:bg-darkRed bg-customRed'}`}
                                    onClick={handleSubmit}
                                >
                                    {buttonLoading ? <Loading size={26} invert /> :
                                        <>
                                            <span>Join Us</span>
                                            <img className="w-[8px] h-[14px] ml-[20px]" src={"/arrow_forward.svg"} alt="arrow_forward" />
                                        </>
                                    }
                                </button>
                            </div>

                
                        </div>
                    </div>
                    <div className="absolute right-5 top-5 cursor-pointer" onClick={closeModel}>
                        <img src='/cross.svg' alt='cross' className="h-5 w-5 lg:invert-0 invert"/>
                    </div>

{/*                     <div className="absolute bottom-0 right-0 lg:block hidden">
                        <img src="/join-us-img.png" alt="Account Setup Logo" className="xl-xxl:max-w-full max-w-[80%]" />
                    </div> */}
                </div>
            </div>
        </div>
    )
}
export default JoinusModel;
